import '../assets/trigger.css';
import { jsx as e } from "react/jsx-runtime";
import { Popover as b } from "@datamole/wds-component-popover";
import { Slot as f } from "@radix-ui/react-slot";
import h from "clsx";
import { forwardRef as w } from "react";
import { useComboboxContext as x } from "../hooks/use-combobox-context.js";
const y = "_trigger_q7sez_3", C = "_trigger_error_q7sez_55", a = {
  trigger: y,
  trigger_error: C
}, u = (n, g) => {
  const { asChild: c, children: o, className: s, onKeyDown: m, ...t } = n, { setIsMenuOpen: l, hasError: d, disabled: r, onClear: p } = x(), _ = (i) => {
    switch (i.key) {
      case "Enter":
      case "ArrowDown":
      case "ArrowUp":
        l(!0);
        break;
      case "Delete":
      case "Backspace":
        r || p();
        break;
    }
    m?.(i);
  };
  return /* @__PURE__ */ e(b.Trigger, { asChild: !0, children: c ? /* @__PURE__ */ e(f, { ...t, className: s, children: o }) : /* @__PURE__ */ e(
    "div",
    {
      ...t,
      ref: g,
      "aria-disabled": r,
      className: h(a.trigger, s, { [a.trigger_error]: d }),
      tabIndex: r ? -1 : 1,
      onKeyDown: _,
      children: o
    }
  ) });
}, D = w(u);
D.displayName = "Combobox.Trigger";
export {
  D as Trigger
};
